if (!customElements.get('accordion-content')) {
  class AccordionContent extends HTMLElement {
    static observedAttributes = ['open'];

    #transitionEndHandler = null;
    #openRafId = null;

    constructor() {
      super();

      this.open = this.getAttribute('open') == 'true';

      this.enabled = true;
      this.enableDesktop = this.getAttribute('enable-desktop') == 'true';

      this.elToggle = this.querySelector('[data-toggle]');
      this.elContent = this.querySelector('[data-content]');
      this.elSection = this.closest('[data-accordions-section]');

      this.elToggle.addEventListener('click', this.toggleAccordion.bind(this));
    }

    #detachTransitionListener() {
      if (this.#transitionEndHandler) {
        this.removeEventListener('transitionend', this.#transitionEndHandler);
        this.#transitionEndHandler = null;
      }
    }

    #clearPendingAnimations() {
      if (this.#openRafId != null) {
        cancelAnimationFrame(this.#openRafId);
        this.#openRafId = null;
      }
      this.#detachTransitionListener();
    }

    connectedCallback() {
      if (!this.enableDesktop) {
        const enableDisableDesktop = () => {
          const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
          isDesktop ? this.disable() : this.enable();
        };
        enableDisableDesktop();
        window.addEventListener('resize', enableDisableDesktop);
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      this.#clearPendingAnimations();

      if (newValue == 'true') {
        this.open = true;
        this.classList.add('visible');
        this.#openRafId = requestAnimationFrame(() => {
          this.#openRafId = null;
          if (this.getAttribute('open') !== 'true') return;
          this.classList.add('open');

          const handler = (event) => {
            if (event.target !== this || event.propertyName !== 'grid-template-rows') return;
            this.#detachTransitionListener();
            if (this.getAttribute('open') !== 'true') return;
            this.elToggle.setAttribute('aria-expanded', 'true');
            this.elContent.setAttribute('aria-hidden', 'false');
          };

          this.#transitionEndHandler = handler;
          this.addEventListener('transitionend', handler);
        });
      } else {
        this.open = false;
        this.classList.remove('open');
        this.elToggle.setAttribute('aria-expanded', 'false');
        this.elContent.setAttribute('aria-hidden', 'true');

        const handler = (event) => {
          if (event.target !== this || event.propertyName !== 'grid-template-rows') return;
          this.#detachTransitionListener();
          if (this.getAttribute('open') !== 'false') return;
          this.classList.remove('visible');
        };

        this.#transitionEndHandler = handler;
        this.addEventListener('transitionend', handler);
      }
    }

    toggleAccordion() {
      this.setAttribute('open', !this.open);
      if (this.elSection) {
        const { exclusive } = this.elSection.dataset;
        const shouldCloseOtherAccordions = exclusive == 'true';
        const elOtherAccordions = [...this.elSection.querySelectorAll('accordion-content')].filter((el) => {
          const { id } = el.querySelector('button');
          return id !== this.elToggle.id;
        });

        shouldCloseOtherAccordions && elOtherAccordions.forEach((el) => el.setAttribute('open', false));
      }
    }

    disable() {
      this.enabled = false;
      this.elToggle.disabled = true;
      this.setAttribute('open', true);
    }

    enable() {
      this.enabled = true;
      this.elToggle.disabled = false;
      this.setAttribute('open', false);
    }
  }
  customElements.define('accordion-content', AccordionContent);
}
